import React from "react";
import { Button, Grid, Icon } from "semantic-ui-react";
import { subStrWithEllipsis } from "../utils/DataUtils";
import NoData from "../utils/NoData";
const Gallery = ({
  categories,
  data,
  page,
  pageColumns,
  readMoreText,
  noDataMessage,
  setPage
}) => {
  const nrOfColumns = +pageColumns;
  return data.content && data.content.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
    columns: nrOfColumns,
    className: "resources-wrapper"
  }, data.content.map(resource => {
    let url = '#';
    if (resource.url) {
      url = resource.url;
    } else if (resource.fileMetadata && resource.fileMetadata.blob === true) {
      url = process.env.REACT_APP_ADMIN_API + "/country/resource/stream?resourceId=" + resource.id;
    } else if (resource.fileMetadata && resource.fileMetadata.blob === false) {
      url = process.env.REACT_APP_ADMIN_API + "/country/resource/file?resourceId=" + resource.id;
    }
    return /*#__PURE__*/React.createElement(Grid.Column, {
      verticalAlign: "middle",
      key: resource.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "resources-info"
    }, /*#__PURE__*/React.createElement("p", {
      className: "resources-info-heading"
    }, resource.categoryIds.map(id => categories[id] && categories[id]['label'] ? categories[id]['label'] + ' ' : '')), /*#__PURE__*/React.createElement("p", {
      className: "resources-info-title",
      title: resource.title
    }, getMax100Chars(resource.title)), /*#__PURE__*/React.createElement("p", {
      className: "resources-info-description",
      title: resource.description
    }, getMax150Chars(resource.description)), /*#__PURE__*/React.createElement("p", {
      className: "resources-info-read-more-wrapper"
    }, /*#__PURE__*/React.createElement("a", {
      className: "link-with-arrow green resources-info-read-more",
      href: url,
      target: "_blank",
      rel: "noopener noreferrer"
    }, readMoreText))));
  }).reduce((prev, curr) => {
    if (!prev.length || prev[prev.length - 1].length === nrOfColumns) {
      prev.push([]);
    }
    prev[prev.length - 1].push(curr);
    return prev;
  }, []).map((cols, index) => /*#__PURE__*/React.createElement(Grid.Row, {
    key: index,
    stretched: true
  }, cols, " "))), /*#__PURE__*/React.createElement(Grid, {
    columns: 2,
    className: "resources-navigation"
  }, /*#__PURE__*/React.createElement(Grid.Column, {
    textAlign: "left"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: true,
    basic: true,
    color: "brown",
    size: "tiny",
    disabled: data.first,
    onClick: () => {
      const prev = page - 1;
      if (prev >= 0) {
        setPage(page - 1);
      }
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron left"
  }))), /*#__PURE__*/React.createElement(Grid.Column, {
    textAlign: "right"
  }, /*#__PURE__*/React.createElement(Button, {
    icon: true,
    basic: true,
    color: "brown",
    size: "tiny",
    disabled: data.last,
    onClick: () => {
      setPage(page + 1);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevron right"
  }))))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(NoData, {
    message: noDataMessage
  }), /*#__PURE__*/React.createElement("br", null));
};
const getMax100Chars = str => subStrWithEllipsis(str, 100);
const getMax150Chars = str => subStrWithEllipsis(str, 150);
export default Gallery;